module.exports = __webpack_public_path__ + "static/media/starter-polygon.1a8d45d1.png";